import React from 'react';
import LoadingCard from './Loading';

const MobileWorksView = ({ 
  worksData, 
  loading, 
  currentSlide, 
  scrollContainerRef, 
  setCurrentSlide,
  onScroll
}) => {
  
  // Handle manual scroll to update indicators
  const handleScroll = (e) => {
    if (onScroll) {
      onScroll();
    }
  };

  // Handle indicator click
  const handleIndicatorClick = (index) => {
    setCurrentSlide(index);
    
    // Scroll to the selected card
    if (scrollContainerRef.current) {
      const container = scrollContainerRef.current;
      const cardWidth = container.children[0]?.offsetWidth + 16;
      const scrollPosition = index * cardWidth;
      
      container.scrollTo({
        left: scrollPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <div className="mobile-scroll-container">
      <div 
        className="mobile-works-wrapper" 
        ref={scrollContainerRef}
        onScroll={handleScroll}
      >
        {loading ? (
          Array(3).fill(0).map((_, index) => (
            <LoadingCard key={index} isMobileCard={true} />
          ))
        ) : (
          worksData.map((work) => (
            <div key={work.id} className="mobile-work-card">
              <div className="work-card h-90">
                {/* Project Image */}
                <div className="work-image-container">
                  <img 
                    src={work.image} 
                    alt={work.title}
                    className="work-image"
                    onError={(e) => {
                      e.target.src = "https://images.unsplash.com/photo-1557804506-669a67965ba0?w=400&h=250&fit=crop";
                    }}
                  />
                  <div className="category-badge1">
                    {work.category}
                  </div>
                </div>

                {/* Card Content */}
                <div className="card-content">
                  <h1 className="card-title">
                    {work.title}
                  </h1>
                  
                  <h2 className="card-description">
                    {work.description}
                  </h2>
                </div>
              </div>
            </div>
          ))
        )}
      </div>

      {/* Slide Indicators */}
      {!loading && worksData.length > 0 && (
        <div className="slide-indicators">
          {worksData.map((_, index) => (
            <div
              key={index}
              className={`slide-indicator ${index === currentSlide ? 'active' : ''}`}
              onClick={() => handleIndicatorClick(index)}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default MobileWorksView;